import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    BlogsComponent,
    GoogleTagManagerService,
    SlideshowComponent,
    ToastmessageService,
    TranslationService
} from '@prekog/common-ui';
import { ConsultationComponent } from '../consultation/consultation.component';
import { HomeConfig } from './home-config';
import { HomeConfigResponse } from './homeconfigresponse';

@Component({
    selector: 'pf-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [SlideshowComponent, ConsultationComponent, BlogsComponent, CommonModule, RouterModule]
})
export class HomeComponent implements OnInit {
    bookAppointmentsUrl = 'https://medicall.cc/idopontfoglalas/regenero/index';
    configuratorBaseUrl = '';
    getHomeConfigsUrl = '/websiteconfigurator/get-homeconfigs';

    googleMapIframeSrc?: SafeResourceUrl | null = null;
    homeConfigList: HomeConfig[] = [];

    nameOfLink = 'IDŐPONTFOGLALÁS LINK MEGTEKINTÉSE';

    constructor(
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _translateService: TranslationService,
        private readonly _domSanitizer: DomSanitizer,
        private _googleTagManagerService: GoogleTagManagerService,
        private _router: Router
    ) {
        this.configuratorBaseUrl = _configuratorBaseUrl;
    }

    ngOnInit(): void {
        const unsafeUrl = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBSYe-gDScK77G0sZGbV3Ab_FFKizyP_xo&q=Regenero';
        const trustedUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
        this.googleMapIframeSrc = trustedUrl;

        this._apiRequestService
            .sendRequest<{}, HomeConfigResponse>(this.configuratorBaseUrl, {}, true, this.getHomeConfigsUrl)
            .subscribe((response) => {
                this.homeConfigList = response.homeConfigList as HomeConfig[];
            });
    }

    settingUpLinkToGoogleAnalytics() {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, this.bookAppointmentsUrl);
    }
}
